
export default function AutoSteeringHeroSection() {
  const handleConsultationClick = () => {
    const ctaSection = document.querySelector('[data-cta-section]');
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-[70vh] md:h-[70vh] sm:h-[60vh] flex items-center justify-center overflow-hidden">
      {/* 背景画像 */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/f25082a5c5cad758bb51d6bb196ff720.webp')`
        }}
      ></div>

      {/* オーバーレイ */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* コンテンツ */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 sm:px-4">
        <div className="flex items-center justify-start">
          <div className="text-white max-w-2xl ml-2 sm:ml-0">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-3 leading-tight sm:leading-snug">
              最適な一台が、<br />
              あなたの<span className="text-[#76B947]">農業を加速</span>させる。
            </h1>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-8 sm:mb-6 leading-relaxed sm:leading-relaxed">
              RTK技術で実現する精密農業。<br className="hidden sm:block" />
              作業効率向上と燃料コスト削減を同時に実現する<br className="hidden sm:block" />
              次世代農業ソリューション
            </p>

            <div className="flex justify-start items-start">
              <button 
                onClick={handleConsultationClick}
                className="px-6 sm:px-4 md:px-8 py-3 sm:py-2 bg-[#FFC107] text-black rounded-lg hover:bg-yellow-500 transition-colors text-sm sm:text-base md:text-lg font-bold whitespace-nowrap cursor-pointer"
              >
                専門家に無料で相談する
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
